import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { bonuses } from '../../data/bonuses';
export function BonusesSection() {
  return <section className="bg-zinc-950 px-5 py-20 md:py-28" data-id="element-68" data-mp="qcz88ancji6x">
      <div className="mx-auto max-w-6xl" data-id="element-69" data-mp="qek361dkp35b">
        <SectionHeading title={<>Y además recibís <span className="text-accent" data-id="element-71" data-mp="vclm8mb012gs">5 bonos prácticos.</span></>} data-id="element-70" data-mp="vbk828yorzuu" />

        <ul className="mt-14 flex flex-wrap justify-center gap-5" data-id="element-72" data-mp="1j0v5bggtvc48">
          {bonuses.map(b => <li key={b.label} className="flex w-full flex-col rounded-xl border border-zinc-800 bg-zinc-900 p-7 sm:w-[calc(50%-0.625rem)] lg:w-[calc(33.333%-0.84rem)]" data-id="element-73" data-mp="1o07z6l649jgb">
              <div className="flex items-center gap-2.5" data-id="element-74" data-mp="199ilnc56ns9a">
                <GiftIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-75" data-mp="1e9muqh3rhkph" />
                <p className="text-sm font-bold uppercase tracking-widest text-gold" data-id="element-76" data-mp="21zqu2c9x2yao">{b.label}</p>
              </div>
              <h3 className="font-display mt-3 text-2xl font-extrabold uppercase leading-tight text-zinc-50 md:text-3xl" data-id="element-77" data-mp="26s0syht0f8p3">{b.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-zinc-400 md:text-lg" data-id="element-78" data-mp="2m5s8gj73p4l0">{b.body}</p>
              <p className="mt-auto pt-5" data-id="element-79" data-mp="2h88rhbj0qdpd">
                <span className="block border-t border-zinc-800 pt-4 text-xs font-bold uppercase tracking-wide text-accent md:text-sm" data-id="element-80" data-mp="2vvttt382k8w8">
                  {b.highlight}
                </span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}